// invoiceService.ts
import apiService from './api';
import {
  Invoice,
  CreateInvoiceData,
  UpdateInvoiceData,
  InvoiceFilters
} from '../types/invoiceTypes';

class InvoiceService {
  async getInvoices(filters?: InvoiceFilters): Promise<Invoice[]> {
    const params = new URLSearchParams();
    if (filters?.customer_id) params.append('customer_id', filters.customer_id.toString());
    if (filters?.status) params.append('status', filters.status);
    if (filters?.payment_status) params.append('payment_status', filters.payment_status);
    if (filters?.date) params.append('date', filters.date);

    const response = await apiService.get<Invoice[]>(
      `/orders/invoices${params.toString() ? `?${params.toString()}` : ''}`
    );
    console.log("response:::::::", response)
    return response.data;
  }

  async getInvoiceById(id: string): Promise<Invoice> {
    const response = await apiService.get<Invoice>(
      `/orders/invoices/${id}`
    );
    return response.data;
  }

  async createInvoice(data: CreateInvoiceData): Promise<Invoice> {
    const response = await apiService.post<{ status: boolean; data: Invoice }>(
      '/orders/invoices',
      data
    );
    return response.data.data;
  }

  async updateInvoice(data: UpdateInvoiceData): Promise<Invoice> {
    const { id, ...updateData } = data;
    const response = await apiService.put<{ status: boolean; data: Invoice }>(
      `/orders/invoices/${id}`,
      updateData
    );
    return response.data.data;
  }

  async deleteInvoice(id: string): Promise<void> {
    await apiService.delete(`/orders/invoices/${id}`);
  }

  async updateInvoiceStatus(id: string, status: string): Promise<Invoice> {
    const response = await apiService.patch<{ status: boolean; data: Invoice }>(
      `/orders/invoices/${id}/status`,
      { status }
    );
    return response.data.data;
  }
}

export const invoiceService = new InvoiceService();
export default invoiceService;